import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VideoResponse } from '../model/video-response.model';

@Injectable({
  providedIn: 'root'
})
export class VideoService {

  private apiUrl = environment.baseApiUrl + "/videos";

  constructor(private http: HttpClient) { }

  getVideos(page: number, limit: number): Observable<VideoResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())

    return this.http.get<VideoResponse>(this.apiUrl, { params });
  }
  
}
